import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="public-light bg-[#050505] min-h-screen text-[#F5F2EB]">
      <Navbar/>
      <main className="max-w-3xl mx-auto px-6 pt-32 pb-20">
        <div className="text-[10px] tracking-[0.32em] uppercase text-[#DC2626] font-medium">Legal</div>
        <h1 className="font-serif text-4xl md:text-5xl mt-3 text-[#18181b] leading-tight">Privacy Policy</h1>
        <p className="text-xs text-[#71717a] mt-3">Last updated: February 17, 2026</p>

        <div className="prose prose-sm max-w-none mt-10 space-y-6 text-[#3f3f46]">
          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">1. Information We Collect</h2>
            <p>When you book a ride or create an account with Delux Limo Trans Group LLC ("Delux Limo", "we", "us"), we collect:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Contact information</strong>: name, phone number, email address.</li>
              <li><strong>Trip details</strong>: pickup and drop-off addresses, dates, times, passenger count, flight numbers, and any special notes you provide.</li>
              <li><strong>Payment information</strong>: processed securely by Square; we do not store card numbers on our servers.</li>
              <li><strong>Driver location data</strong>: when an assigned driver opts in via their browser, we record GPS positions during your active trip to display real-time tracking to you. Location data is retained for the duration of the trip plus 30 days for support purposes.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">2. How We Use Your Information</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>To confirm, schedule, and fulfill your reservation.</li>
              <li>To send you booking confirmations, driver assignment notifications, real-time trip status updates (driver en-route, arrived, dropped off), and payment receipts via SMS and email.</li>
              <li>To allow drivers to contact you about your trip.</li>
              <li>To provide customer support and respond to inquiries.</li>
              <li>To improve our service quality.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">3. SMS / Text Messaging</h2>
            <p>By providing your phone number during booking, you consent to receive SMS notifications related to your trip — including confirmations, driver assignment, real-time status updates, payment links, and reminders. Message and data rates may apply. Message frequency varies based on your trip activity.</p>
            <p>Reply <strong>STOP</strong> at any time to unsubscribe. Reply <strong>HELP</strong> for assistance, or call us at (414) 333-6275. You can also email <a href="mailto:reservations@deluxlimotransgroup.com" className="text-[#DC2626] underline">reservations@deluxlimotransgroup.com</a>.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">4. Information Sharing</h2>
            <p>We do <strong>not</strong> sell, rent, or share your personal information with third parties for marketing purposes. We share your information only with:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>The driver assigned to your trip (contact info needed to complete the ride).</li>
              <li>Service providers required to deliver our service — Square (payments), Twilio (SMS), Resend (email), Google Maps (routing). Each provider has its own privacy policy and security standards.</li>
              <li>Law enforcement when required by a valid legal request.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">5. Data Retention</h2>
            <p>We retain your trip history and contact records for as long as your account is active or as required for tax, accounting, and legal compliance (typically 7 years for booking and payment records). You may request deletion of your account by emailing <a href="mailto:reservations@deluxlimotransgroup.com" className="text-[#DC2626] underline">reservations@deluxlimotransgroup.com</a>.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">6. Your Rights</h2>
            <p>You can request a copy of your personal data, correct inaccuracies, or request deletion at any time by contacting us. We will respond within 30 days.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">7. Security</h2>
            <p>We protect your data using industry-standard encryption (TLS in transit, encrypted storage at rest). However, no system is 100% secure; if you suspect unauthorized access, contact us immediately.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-[#18181b] mt-8 mb-3">8. Contact</h2>
            <address className="not-italic">
              <strong>Delux Limo Trans Group LLC</strong><br/>
              Milwaukee, Wisconsin, United States<br/>
              Phone: <a href="tel:+14143336275" className="text-[#DC2626]">(414) 333-6275</a><br/>
              Email: <a href="mailto:reservations@deluxlimotransgroup.com" className="text-[#DC2626]">reservations@deluxlimotransgroup.com</a>
            </address>
          </section>
        </div>
      </main>
      <Footer/>
    </div>
  );
}
